import add from './add/add.controller';
import remove from './remove/remove.controller';

export default angular.module('mpdx.contacts.bulkActions.tag', [add, remove]).name;
